/** Decides whether a transposed table's property row stays visible when fresh
 * `content` lands from the server.
 *
 * Row visibility is derived from whether the payload carries a value, because
 * that is all the API represents - there is no "this row exists but is empty"
 * on the wire. So a row the coach has turned on but not yet typed into lives
 * only in local state, and deriving visibility from `content` alone erases it
 * the moment any save round-trips (the reducer replaces the whole item with the
 * PUT response, which re-runs the resync effect).
 *
 * `localHadValue` must be the PRE-refetch local value. That is what separates
 * the two cases the server payload looks identical in:
 *
 *   local blank + content blank -> the coach just added it      -> keep
 *   local had a value + content blank -> undo / another edit    -> hide
 *
 * Callers get that for free inside the resync effect: `setRows(...)` there is a
 * setter, so the effect's closure still holds what was on screen.
 */
const keepRowIfLocallyBlank = (contentHasValue, localHadValue, isShowing) => (
  contentHasValue || (isShowing && !localHadValue)
);

export default keepRowIfLocallyBlank;
